/**
 * Llamadas del módulo de Repositorios al backend (/api/repos). Usa el mismo fetch con Bearer
 * que el Creador; el backend valida cada consulta contra el catálogo del repositorio.
 */
import { backendFetch, engineErrorMessage } from '../admin/widget/engineConfig';

async function json(response, fallback) {
    if (!response.ok) throw new Error(await engineErrorMessage(response, fallback));
    return response.json();
}

/** Repositorios visibles para el usuario. */
export async function fetchRepositories() {
    const data = await json(await backendFetch('/api/repos'), 'No se pudieron cargar los repositorios.');
    return data.repositories || [];
}

/** Datasets y enlaces del repositorio. */
export async function fetchCatalog(repo) {
    return json(await backendFetch(`/api/repos/${repo}/catalog`), 'No se pudo cargar el catálogo.');
}

/**
 * Ejecuta varias consultas en una petición.
 * @param {string} repo
 * @param {Array<{id: string}>} queries
 * @returns {Promise<Object<string, {ok: boolean, records?: Array, error?: string}>>}
 */
export async function queryRepository(repo, queries) {
    const data = await json(await backendFetch(`/api/repos/${repo}/query`, {
        method: 'POST',
        body: JSON.stringify({ queries }),
    }), 'No se pudo consultar el repositorio.');
    return data.results || {};
}

/** Vuelve a leer los archivos de Drive (descarta la caché del motor). */
export async function refreshRepository(repo) {
    return json(await backendFetch(`/api/repos/${repo}/refresh`, { method: 'POST', body: '{}' }),
        'No se pudieron actualizar los datos.');
}

/** Descarga filas como CSV (UTF-8 con BOM para que Excel respete los acentos). */
export function downloadCsv(filename, columns, rows) {
    const escape = (value) => {
        const text = value == null ? '' : String(value);
        return /[",\n;]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
    };
    const lines = [columns.map(col => escape(col.label)).join(',')];
    rows.forEach(row => lines.push(columns.map(col => escape(col.value(row))).join(',')));
    const blob = new Blob([`﻿${lines.join('\n')}`], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
